import RuntimeConfig from '../model/RuntimeConfig'

const localRuntimeConfig: RuntimeConfig = {
  ssrSharedCache: false,
  brandName: 'B2C',
  salesChannel: 'webLLY',
  apiGateway: 'https://mas-sales-master.dev-01.k8s.masmovil.com/api',
  vistaApiGateway: 'https://mas-care-front.dev.k8s.masmovil.com/customer',
  consentsUrl: 'https://mas-consents-front.dev.k8s.masmovil.com',
  energyUrl: 'https://manage.masmovilenergia.blue/',
  salesClusterUrl: 'https://sales.sta.k8s.masmovil.com',
  configCatSDKKey: 'SyLYCI3UakmOim9hszs9jA/2UuhmIIM6EGdaIzKbSshZA',
  defaultFeatureFlags: { isOffline: false },
  authn: {
    clientId: 'dNBMSO0Klt7j2Vo7iC1p',
    apiGateway: 'https://authn.sta.masstack.com/v1',
  },
  analytics: {
    UAID: 'UA-2853174-30',
    externalConfigName: 'b2c-sales',
    siteName: 'MAS SALES',
  },
  redisUrl: 'redis://localhost:6379/2',
  environment: 'local',
}

export default localRuntimeConfig
